module.exports = __webpack_public_path__ + "static/img/preview.8c382430.png";